import {createParentPositions, METADATA, ShowerHeadTypes} from "../../constants";
import ShowerCommon from "../showerNew/showerCommon";
import store from "../../../../../store";
import {IS_QKB_UI} from "../../../../../config";

export default class ShowerHead extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_head';
    this.partName = 'Shower Head';
    this.translateId = "visualizer.bathroom.shower.shower_head";
    this.layerPriority = 4;
    this.canBeDisabled = true;
    // this.useMatchingFeatureReplacement = "MountPosition";
    if (isChild) {
      this.previouslySelectedFeatures = {
        Layout1: {},
        Layout4: {},
      };
      createParentPositions(this);
    }
  }

  navigationSubItems(...props) {
    if (IS_QKB_UI) {
      return this.navigationSubItemsWithSides(...props)
    }
    return super.navigationSubItems(...props);
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"] || (Array.isArray(dbFeature.metaData["Side"]) && dbFeature.metaData["Side"][0] === "0")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    return super.load(dbFeature)
  }

  handleClick() {
    this.setArmHeadType();
    super.handleClick();
  }

  applyFeatureIfNotCompatible() {
    const showerParent = this.getParent().getParent();
    if (showerParent.showerFixture) {
      showerParent.showerFixture.disabled = true;
    }
  }

  disabledClick() {
    const showerArm = this.getParent().showerArm;
    if (showerArm) {
      showerArm.disabled = this.disabled || !showerArm.canBeEnabled(); // true or check if it can be enabled
    }
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm && this.activeFeature
  }

  setLayers(layout) {
    const showerParent = this.getParent();
    if (this.hideLayerCondition()) {
      super.hideLayers();
      return;
    }
    if (showerParent.showerArm && showerParent.showerArm.layerPositions && this.layerPositions && this.activeFeature) {
      Object.keys(showerParent.showerArm.layerPositions).forEach(position => {
        if (!this.layerPositions[position] && showerParent.showerArm.layerPositions[position]) {
          this.layerPositions[position] = this.getMatchingPositionFeature(position)
        } else if (this.layerPositions[position] && !showerParent.showerArm.layerPositions[position]) {
          const {wizardActiveItem} = store.getState().wizardState;
          if (!wizardActiveItem || !wizardActiveItem.hideItems) {
            this.layerPositions[position] = null
          }
        }
      })
    }
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const showerParent = this.getParent();
    const showerSize = showerParent.showerSize();
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    if (showerParent.showerArm && showerParent.showerArm.activeFeature && showerParent.showerArm.activeFeature.metaData["MountType"]) {
      conditions.push({
        propName: "MountType",
        propValue: showerParent.showerArm.activeFeature.metaData["MountType"][0]
      })
    }
    if (showerParent.showerArm && showerParent.showerArm.activeFeature && showerParent.showerArm.activeFeature.metaData["MountPosition"]) {
      conditions.push({
        propName: "MountPosition",
        propValue: showerParent.showerArm.activeFeature.metaData["MountPosition"][0]
      })
    }
    return conditions;
  }

  canDisplayDemoPoint() {
    return this.getParent().shower_head_type === ShowerHeadTypes.shower_arm
  }

}
